import { render, staticRenderFns } from "./MyFolderPageNumber.vue?vue&type=template&id=36ed590c&scoped=true&"
import script from "./MyFolderPageNumber.vue?vue&type=script&lang=js&"
export * from "./MyFolderPageNumber.vue?vue&type=script&lang=js&"
import style0 from "./MyFolderPageNumber.vue?vue&type=style&index=0&id=36ed590c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed590c",
  null
  
)

export default component.exports